import api from '@mint-lib/api';
import { TFunction } from '@mint-lib/i18n';

import { UserCurrencyResponseType } from '../../index.js';
import { USER_CURRENCY } from '../endpoints.js';

export const getUserCurrency = async (
  t: TFunction,
): Promise<UserCurrencyResponseType | null> => {
  return api
    .get(USER_CURRENCY)
    .then((data) => {
      return data.data as Promise<UserCurrencyResponseType>;
    })
    .catch((e) => {
      // TODO fix later
      // enqueueSnackbar({
      //   title: t('Error'),
      //   subTitle: t('Unable to load selected user currency.'),
      //   variant: 'error',
      // });

      return null;
    });
};
